<script>
  import { getContext, onMount } from "svelte";
  import { Link, navigate } from "svelte-routing";
  import TallyRequestForm from "#lib/TallyRequestForm.svelte";
  import Navbar from "#lib/Navbar.svelte";
  import NavbarUnauthenticated from "#lib/NavbarUnauthenticated.svelte";
  import Redirect from "./Redirect.svelte";
  import { user } from "#src/stores/auth.js";
  import { api, doesOrgAllowTallyRequest } from "#src/api/";
  import isLoggedIn from "#src/extensions/is-logged-in.js";
  import { getBalances } from "#src/api/stripe.js";

  import CaretLeftIcon from "@local/assets/icons/caret-left.svg";

  export let queryParams = {};

  const org = getContext("org");

  let balances = null;

  async function checkOrgAllowsTallyRequest(org_id) {
    const allows = await doesOrgAllowTallyRequest(org_id);
    if (!allows) {
      navigate("/");
    }
  }

  onMount(async () => {
    if (!$user) {
      await api.auth.signInAnonymously();
    }

    if (isLoggedIn($user)) {
      const b = await getBalances($org.id);
      if (b.balances) {
        balances = b.balances;
      }
    }
  });
</script>

{#if isLoggedIn($user)}
  <Navbar context="tally-request" />

  <div class="text-blue-500 text-sm absolute top-16 left-4">
    <Link to="/" class="flex items-center space-x-1">
      <CaretLeftIcon />
      <div>Dashboard</div>
    </Link>
  </div>
{:else}
  <NavbarUnauthenticated />
{/if}

{#if $org?.id}
  <TallyRequestForm org_id={$org.id} customer_id={$user?.id} {balances} loggedIn />
{:else if queryParams.org_id}
  {#await checkOrgAllowsTallyRequest(queryParams.org_id) then _}
    <TallyRequestForm org_id={queryParams.org_id} customer_id={$user?.id} />
  {/await}
{:else}
  <Redirect to="/" />
{/if}

<style lang="scss">
  .content-container {
    @media (min-width: 640px) {
      width: 32rem;
    }
  }

  .checkbox-container > div {
    @apply flex items-center gap-2 text-xs;
  }
</style>
